import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import account from "@/store/modules/account";
import top from "@/store/modules/top";
import talk_notifieds from '@/store/modules/talk_notifieds';
import notification_form from "@/store/modules/notification_form";
import issuance_request_index from "@/store/modules/issuance_request_index";
import issuance_request_own_index from "@/store/modules/issuance_request_own_index";
import issuance_request_form from "@/store/modules/issuance_request_form";
import issuance_request_download from "@/store/modules/issuance_request_download";
import reissuance_request_form from "@/store/modules/reissuance_request_form";
import account_form from "@/store/modules/account_form";
import brokerage_company_form from "@/store/modules/brokerage_company_form";
import broker_index from "@/store/modules/broker_index";
import broker_form from "@/store/modules/broker_form";
import provisional_brokerage_company_form from "@/store/modules/provisional_brokerage_company_form";
import brokerage_company_register_form from "@/store/modules/brokerage_company_register_form";
import provisional_broker_form from "@/store/modules/provisional_broker_form";
import broker_register_form from "@/store/modules/broker_register_form";
import guest_register_form from "@/store/modules/guest_register_form";
import password_reissue_form from "@/store/modules/password_reissue_form";
import privacy_policy_form from "@/store/modules/privacy_policy_form";
import login_form from "@/store/modules/login_form";
import mail_history_index from "@/store/modules/mail_history_index";
import mail_history_form from "@/store/modules/mail_history_form";
import merger_request_register_form from "@/store/modules/merger_request_register_form";
import merger_request_form from "@/store/modules/merger_request_form";
import public_document_form from "@/store/modules/public_document_form";
import public_document_index from "@/store/modules/public_document_index";
import zendesk from "@/store/modules/zendesk";
import operation_log_index from '@/store/modules/operation_log_index';

export default createStore({
  strict: process.env.NODE_ENV === 'development',

  plugins: [
    createPersistedState({
      key: 'jrepcity-broker',
      paths: [
        'account',
      ],
    })
  ],

  modules: {
    account,
    top,
    talk_notifieds,
    notification_form,
    issuance_request_index,
    issuance_request_own_index,
    issuance_request_form,
    issuance_request_download,
    reissuance_request_form,
    account_form,
    brokerage_company_form,
    broker_index,
    broker_form,
    provisional_brokerage_company_form,
    brokerage_company_register_form,
    provisional_broker_form,
    broker_register_form,
    guest_register_form,
    password_reissue_form,
    privacy_policy_form,
    login_form,
    mail_history_index,
    mail_history_form,
    merger_request_register_form,
    merger_request_form,
    public_document_index,
    public_document_form,
    zendesk,
    operation_log_index,
  },

  state: {
    pageTitle: '',
    pageGroup: '',
    pageLoading: false,
    apiLoading: false,
    originalRoute: null,
    flashMessage: null,
    apiErrorHandled: false,
    noIndex: false,
  },

  mutations: {
    setPageMeta(state, payload) {
      state.pageTitle = payload.title;
      state.pageGroup = payload.group;
      state.noIndex = payload.noIndex;
    },

    setPageLoadingFlag(state) {
      state.pageLoading = true;
    },

    unsetPageLoadingFlag(state) {
      state.pageLoading = false;
    },

    setApiLoadingFlag(state) {
      if (!sessionStorage.getItem('hideApiLoading')) {
        state.apiLoading = true;
      }
    },

    unsetApiLoadingFlag(state) {
      state.apiLoading = false;
    },

    setOriginalRoute(state, payload) {
      state.originalRoute = payload.value;
    },

    setFlashMessage(state, payload) {
      state.flashMessage = payload.value;
    },

    clearFlashMessage(state) {
      state.flashMessage = null;
    },

    setApiErrorHandleStatus(state, payload) {
      state.apiErrorHandled = payload.status;
    },

    clearApiErrorHandleStatus(state) {
      state.apiErrorHandled = false;
    },
  },

  actions: {
    initializeSearchForm: ({ commit }) => {
      // 一覧画面の検索フォームの初期化
      commit('issuance_request_index/resetForms');
      commit('issuance_request_own_index/resetForms');
      commit('broker_index/resetForms');
      commit('operation_log_index/resetForms');
    },

    startPageLoading: ({ commit }) => {
      commit('setPageLoadingFlag');
    },

    stopPageLoading: ({ commit }) => {
      commit('unsetPageLoadingFlag');
    },

    startApiLoading: ({ commit }) => {
      commit('setApiLoadingFlag');
    },

    stopApiLoading: ({ commit }) => {
      commit('unsetApiLoadingFlag');
    },
  },
})
